__turbopack_context__.v({
  "badge": "LocationBadges-module-scss-module__o7DY1a__badge",
  "badgeWrap": "LocationBadges-module-scss-module__o7DY1a__badgeWrap",
  "item": "LocationBadges-module-scss-module__o7DY1a__item",
  "list": "LocationBadges-module-scss-module__o7DY1a__list",
  "listExpanded": "LocationBadges-module-scss-module__o7DY1a__listExpanded",
  "measureChip": "LocationBadges-module-scss-module__o7DY1a__measureChip",
  "measureRoot": "LocationBadges-module-scss-module__o7DY1a__measureRoot",
  "measureRow": "LocationBadges-module-scss-module__o7DY1a__measureRow",
  "overflowButton": "LocationBadges-module-scss-module__o7DY1a__overflowButton",
  "wrapper": "LocationBadges-module-scss-module__o7DY1a__wrapper",
});
